    export const groupingIntervalsByQuickInterval = {
        'CURRENT_HOUR':[
            { name: "10 seconds", value: 10000 },
            { name: "15 seconds", value: 15000 },
            { name: "30 seconds", value: 30000 },
            { name: "1 minute", value: 60000 },
            { name: "2 minutes", value: 120000 },
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 }
        ],
        'CURRENT_DAY':[
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 }
        ],
        'CURRENT_DAY_SO_FAR':[
            { name: "5 minutes", value: 300000 },
            { name: "10 minutes", value: 600000 },
            { name: "15 minutes", value: 900000 },
            { name: "30 minutes", value: 1800000 },
            { name: "1 hour", value: 3600000 },
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 }
        ],
        'CURRENT_MONTH':[
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        'CURRENT_MONTH_SO_FAR':[
            { name: "2 hours", value: 7200000 },
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 }
        ],
        'CURRENT_QUARTER':[
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 },
            { name: "Month", value: 'MONTH' }
        ],
        'CURRENT_QUARTER_SO_FAR':[
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 },
            { name: "Month", value: 'MONTH' }
        ],
        'CURRENT_HALF_YEAR':[
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 },
            { name: "Month", value: 'MONTH' },
            { name: "Quarter", value: 'QUARTER' }
        ],
        'CURRENT_HALF_YEAR_SO_FAR':[
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 },
            { name: "Month", value: 'MONTH' },
            { name: "Quarter", value: 'QUARTER' }
        ],
        'CURRENT_YEAR':[
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 },
            { name: "Month", value: 'MONTH' },
            { name: "Quarter", value: 'QUARTER' }
        ],
        'CURRENT_YEAR_SO_FAR':[
            { name: "5 hours", value: 18000000 },
            { name: "10 hours", value: 36000000 },
            { name: "12 hours", value: 43200000 },
            { name: "1 day", value: 86400000 },
            { name: "7 days", value: 604800000 },
            { name: "30 days", value: 2592000000 },
            { name: "Month", value: 'MONTH' },
            { name: "Quarter", value: 'QUARTER' }
        ]
    };